export default __webpack_public_path__ + "static/media/logo.0a20a078.png";